
import CodeMirror from 'codemirror'
import Scanner from './../Core/Parser/Scanner'

(function (CodeMirror) {
    CodeMirror.defineMode('psflex', function () {
        let config = window.LangConfig.getTokens()
        let scanner = Scanner(config, window.LangConfig.isCaseSensitive(), function () {

        })

        return {
            token: function (stream) {
                try {
                    let style = ''
                    let code = stream.string.substr(stream.start)

                    if (!scanner.analyze(code)) {
                        stream.skipToEnd()
                        return
                    }

                    let token = scanner.consume()
                    while (typeof token === 'string') {
                        for (let i = 0; i < token.length; i++) {
                            stream.next()
                        }
                        token = scanner.consume()
                    }
                    let eat = token.column
                    if (token.code === config.CONS_INT.code || token.code === config.CONS_FLOAT.code) {
                        while (stream.next() === 0) {
                        }
                    }

                    while (eat > 0) {
                        stream.next()
                        eat--
                    }
                    if (token.code === config.K_WRITE.code || token.code === config.K_READ.code || token.code === config.K_CLEAR_SCREEN.code || token.code === config.K_KEY.code || token.code === config.K_WAIT.code) {
                        if (token.lexema.toLowerCase() === config.K_WRITE.keywords[0].toLowerCase() || token.lexema.toLowerCase() === config.K_READ.keywords[0].toLowerCase() || token.code === config.K_CLEAR_SCREEN.code || token.code === config.K_KEY.code || token.code === config.K_WAIT.code) {
                            stream.match(token.lexema)
                            style = 'variable-2'
                        } else {
                            stream.match(token.lexema)
                            style = ''
                        }
                    } else if (token.code >= 4000 && token.code <= 5999) {
                        stream.match(token.lexema)
                        style = 'keyword'
                    } else if (token.code === config.CONS_STRING.code) {
                        stream.match('"' + token.lexema + '"')
                        style = 'string'
                    } else if (token.code === config.CONS_CHAR.code) {
                        stream.match('\'' + String.fromCharCode(token.lexema.toFixed(0)) + '\'')
                        style = 'string'
                    } else if (token.code === config.CONS_BOOL.code) {
                        if (token.lexema) {
                            stream.match(new RegExp('^' + config.CONS_BOOL.keywords[0], 'i'))
                        } else {
                            stream.match(new RegExp('^' + config.CONS_BOOL.keywords[1], 'i'))
                        }
                        style = 'keyword'
                    } else if (token.code === config.CONS_FLOAT.code || token.code === config.CONS_INT.code) {
                        stream.match(token.lexema)
                        style = 'number'
                    } else if (token.code !== -1) {
                        stream.match(token.lexema)
                    } else {
                        let next
                        while (!stream.eol()) {
                            next = stream.next()
                            if (next === '#') {
                                style = 'comment'
                                stream.skipToEnd()
                                break
                            } else if (next === '/' && stream.next() === '/') {
                                style = 'comment'
                                stream.skipToEnd()
                                break
                            }
                        }
                    }
                    return style
                } catch (e) {
                    console.log('Error: ', e)
                    stream.skipToEnd()
                }
            }
        }
    })
})(CodeMirror)



// WEBPACK FOOTER //
// ./src/Codemirror/mode.js